module.exports = __webpack_public_path__ + "fonts/Noto_Sans_TC-300-589.eb65af1.woff2";